import { COMPANY } from './company'

/**
 * ─────────────────────────────────────────────────────────────
 *  HOW TO RECEIVE ENQUIRY EMAILS
 * ─────────────────────────────────────────────────────────────
 *  The enquiry form posts to Web3Forms, which forwards every
 *  submission straight to your inbox. No server or backend needed.
 *
 *  1. Go to https://web3forms.com
 *  2. Enter info@fundingreferrals.net and press "Create Access Key".
 *  3. Confirm the verification email Web3Forms sends you.
 *  4. Paste the key they give you between the quotes below.
 *
 *  Until a real key is pasted in, the form runs in demo mode:
 *  it validates and shows the success state but sends nothing.
 * ─────────────────────────────────────────────────────────────
 */
export const WEB3FORMS_ACCESS_KEY = '13451597-a00d-4422-8b5b-f5314d13c39b'

export const FORM_ENDPOINT = 'https://api.web3forms.com/submit'

export const NOTIFICATION_EMAIL = COMPANY.email

export const isFormConfigured = () =>
  WEB3FORMS_ACCESS_KEY.length > 20 && !WEB3FORMS_ACCESS_KEY.startsWith('YOUR-')
